import '../css/app.less';

import { initRoutes } from '@eidellev/adonis-stardust/client';
initRoutes();

import './modules/set-css-variables';
import './modules/lazysizes';
import { openModal, initModals } from './modules/modal';
import './modules/termly';

import './modules/ie-banner';
import './modules/scrollmagic';
import { initForms } from './modules/forms';
import './modules/format-phone-inputs';
import './modules/phone-validation';
import './modules/nav';
import './modules/promo-banner';
import './modules/accordion-init';
import './modules/cart-drawer';
import './modules/reward-selection-drawer';
// Initialize promo details listeners globally: the PDP multi-promo drawer
// (.js-toggle-promo-details) and the single-promo detail modal (.js-view-promo-detail).
import './modules/promo-details-drawer';
import './modules/account-drawer';
import './modules/sign-in-drawer';
import './modules/list-drawer';
import './modules/view-toggle';
import './modules/flipp';

import './modules/page-load';
import './modules/sliders';
import './modules/fancybox';
import './modules/scrolling-links';

// import FeedbackWidget from './modules/feedback-widget';
import EcommerceAnalytics from './modules/ecommerce-analytics';

import initTippy from './modules/init-tippy';

import initAutocomplete from './modules/search/init-autocomplete';
import { mapsExists, initMaps } from './modules/google-maps';
import styles from './modules/json/snazzy-maps';

import './modules/global-cart';

document.addEventListener('DOMContentLoaded', async () => {
  initForms();

  initAutocomplete();

  initTippy();

  // new FeedbackWidget();
  const ecommerceAnalytics = new EcommerceAnalytics();

  if (document.querySelector('.js-map') !== null) {
    if (!mapsExists()) {
      await initMaps(styles);
    }
  }

  initModals();

  // Fire the 'login' event if have 'login' param in the URL
  const urlParams = new URLSearchParams(window.location.search);
  const loginMethodParam = urlParams.get('login');
  if (loginMethodParam) {
    ecommerceAnalytics.trackLogin(loginMethodParam);

    // Remove the login param from the URL without reloading the page
    urlParams.delete('login');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState({}, document.title, newUrl);
  }

  // Open a modal on page load if ?modal= is present in the URL
  const modalParam = urlParams.get('modal');
  if (modalParam) {
    openModal(modalParam);
    urlParams.delete('modal');
    const newUrl = window.location.pathname
      + (urlParams.toString() ? '?' + urlParams.toString() : '')
      + window.location.hash;
    window.history.replaceState({}, document.title, newUrl);
  }

  // If we have analytics events to fire on page load, do it now
  if (window.analytics) {
    window.analytics.onload?.forEach((item) => {
      // TODO: Support more events, or use a generic signature?
      switch (item.event) {
        case 'view_cart':
          ecommerceAnalytics.trackViewCart({
            items: item.data.items!,
          });
          break;
        case 'view_item':
          ecommerceAnalytics.trackViewItem({
            items: item.data.items!,
          });
          break;
        case 'search':
          // TODO: The Klaviyo event supports a results count, but we don't have that available on page load.
          ecommerceAnalytics.trackSearch(item.data.query!);
          break;
        default:
          console.debug(`Unsupported analytics method: ${item.event}`);
          return;
      }
    });
  }
});
